export default [
    { 
        label: "Coworker",
        value: "Coworker"
      },
      { 
        label: "Email",
        value: "Email"
      },
      { 
        label: 'Employer',
        value: 'Employer'
      },
      { 
        label: "Family/Friend",
        value: "Family/Friend"
      },
      { 
        label: "Information Session",
        value: "Information Session"
      },
      { 
        label: 'Magazine/Newspaper',
        value: 'Magazine/Newspaper'
      },
      { 
        label: "Online",
        value: "Online"
      },
      { 
        label: "Professional Organization",
        value: "Professional Organization"
      },
      { 
        label: 'Radio/TV',
        value: 'Radio/TV'
      }
]